import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { GetMeResponse, AuthUser } from "./types";

interface AuthState {
  isAuth: boolean;
  mustChangePassword: boolean;
  sessionCheckDone: boolean;
  isLoggingOut: boolean;
  data: {
    user: AuthUser | null;
  } | null;
}

const initialState: AuthState = {
  isAuth: false,
  mustChangePassword: false,
  sessionCheckDone: false,
  isLoggingOut: false,
  data: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<GetMeResponse>) => {
      state.isAuth = true;
      state.isLoggingOut = false;
      const payload = action.payload;

      const userData: AuthUser = {
        id: payload.id,
        email: payload.email,
        login: payload.login,
        user_type: payload.user_type,
        must_change_password: payload.must_change_password,
        is_active: payload.is_active,
        organization: payload.organization,
        profile: {
          type: payload.profile.type,
          id: payload.profile.id,
          full_name: payload.profile.full_name,
          phone: payload.profile.phone,
          job_position_ru: payload.profile.job_position_ru,
          job_position_kk: payload.profile.job_position_kk,
          service_name: payload.profile.service_name,
          vacation_days: payload.profile.vacation_days,
          status: payload.profile.status,
          worker_profile: payload.profile.worker_profile,
        },
        roles: payload.roles || [],
        permissions: payload.permissions || [],
        has_worker_profile: payload.has_worker_profile ?? false,
        pending_actions_count: payload.pending_actions_count ?? 0,
        iin: payload.iin ?? null,
      };

      state.data = {
        user: userData,
      };
      state.mustChangePassword = payload.must_change_password;
    },
    setMustChangePassword: (state, action: PayloadAction<boolean>) => {
      state.mustChangePassword = action.payload;
      if (state.data?.user) {
        state.data.user.must_change_password = action.payload;
      }
    },
    logout: (state) => {
      state.isAuth = false;
      state.mustChangePassword = false;
      state.sessionCheckDone = false;
      state.data = null;
    },
    clearMustChangePassword: (state) => {
      state.mustChangePassword = false;
      if (state.data?.user) {
        state.data.user.must_change_password = false;
      }
    },
    setSessionCheckDone: (state, action: PayloadAction<boolean>) => {
      state.sessionCheckDone = action.payload;
    },
    setLoggingOut: (state, action: PayloadAction<boolean>) => {
      state.isLoggingOut = action.payload;
    },
    decrementPendingActionsCount: (state) => {
      if (state.data?.user && state.data.user.pending_actions_count > 0) {
        state.data.user.pending_actions_count -= 1;
      }
    },
  },
});

export const {
  setAuth,
  setMustChangePassword,
  logout,
  clearMustChangePassword,
  setSessionCheckDone,
  setLoggingOut,
  decrementPendingActionsCount,
} = authSlice.actions;
export default authSlice.reducer;
